import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

function DragAndDrop({ onFilesDrop, fromFormat }) {
  const [isDragging, setIsDragging] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    setIsDragging(false);
    onFilesDrop(acceptedFiles);
  }, [onFilesDrop]);

  const getAcceptedFileTypes = () => {
    const acceptedTypes = {
      'png': { 'image/png': ['.png'] },
      'jpeg': { 'image/jpeg': ['.jpg', '.jpeg'] },
      'heic': { 
        'image/heic': ['.heic', '.HEIC'],
        'application/octet-stream': ['.heic', '.HEIC']
      },
      'tiff': {
        'image/tiff': ['.tiff', '.tif', '.TIFF', '.TIF']
      },
      'webp': { 'image/webp': ['.webp'] }
    };
    
    return acceptedTypes[fromFormat.toLowerCase()] || {};
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: getAcceptedFileTypes(),
    multiple: true
  });

  return (
    <div
      {...getRootProps()}
      className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer
        ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300'}`}
      onDragEnter={() => setIsDragging(true)}
      onDragLeave={() => setIsDragging(false)}
    >
      <input {...getInputProps()} />
      <p className="text-gray-600">
        Drag and drop {fromFormat.toUpperCase()} images here, or click to select files
      </p>
      <p className="text-sm text-gray-500 mt-2">
        Supported formats: {Object.values(getAcceptedFileTypes())
          .flatMap(type => Object.values(type))
          .flat()
          .join(', ')}
      </p>
    </div>
  );
}

export default DragAndDrop;
